var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"ui container"},[_c('p',[_vm._v(" © 2022 Powered by Survello "),(_vm.currentVersion)?_c('span',[_vm._v(" · Version "+_vm._s(_vm.currentVersion))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }